import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

const AddIconGeneral = ({ size }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="75"
        height="74"
        viewBox="0 0 75 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" width="74" height="74" rx="37" fill={theme.palette.primary.main} />
        <path
          d="M36.1667 36.1667H36.6667V35.6667V24.3333C36.6667 23.8731 37.0398 23.5 37.5 23.5C37.9602 23.5 38.3333 23.8731 38.3333 24.3333V35.6667V36.1667H38.8333H50.1667C50.6268 36.1667 51 36.5398 51 37C51 37.4602 50.6268 37.8333 50.1667 37.8333H38.8333H38.3333V38.3333V49.6667C38.3333 50.1268 37.9602 50.5 37.5 50.5C37.0398 50.5 36.6667 50.1268 36.6667 49.6667V38.3333V37.8333H36.1667H24.8333C24.3731 37.8333 24 37.4602 24 37C24 36.5398 24.3731 36.1667 24.8333 36.1667H36.1667Z"
          fill="white"
          stroke="white"
        />
      </svg>
    </SvgIcon>
  );
};

export default AddIconGeneral;
